// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"695":"441d59f4","757":"e0978ef7"}[chunkId] + ".chunk.css";
};